import type { MessageKey } from '@/features/i18n/messages/fr';

export const en: Record<MessageKey, string> = {
  'nav.dashboard': 'Dashboard',
  'nav.conception': 'Design',
  'nav.planification': 'Planning',
  'nav.pilotage': 'Operations',
  'nav.marketplaceCrm': 'Marketplace & CRM',
  'nav.network': 'Network & knowledge',
  'nav.accompagnement': 'Mentoring',
  'nav.concours': 'Contest',
  'nav.assistance': 'Support',
  'nav.projects': 'My projects',
  'nav.subscription': 'Subscription',
  'nav.profile': 'Profile',
  'nav.signOut': 'Sign out',
  'nav.group.parcours': 'Learning path',
  'nav.group.outils': 'Tools & community',
  'nav.group.compte': 'My space',
  'nav.more': 'More',
  'nav.moreTitle': 'More sections',
  'nav.short.dashboard': 'Home',
  'nav.short.conception': 'Design',
  'nav.short.planification': 'Plan',
  'nav.short.pilotage': 'Ops',
  'nav.short.marketplaceCrm': 'Market',
  'shell.eyebrow': 'Entrepreneur space',
  'shell.menu': 'Menu',
  'shell.close': 'Close',
  'shell.role.entrepreneur': 'Entrepreneur',
  'lang.fr': 'FR',
  'lang.en': 'EN',
  'mkt.nav.homeAria': 'ISBD — home',
  'mkt.nav.menu': 'Menu',
  'mkt.nav.parcours': 'Journey',
  'mkt.nav.offres': 'Offers',
  'mkt.nav.marketplace': 'Marketplace',
  'mkt.nav.equipe': 'Team',
  'mkt.nav.contact': 'Contact',
  'mkt.nav.login': 'Sign in',
  'mkt.nav.register': 'Create an account',
  'mkt.footer.tagline':
    'Integrated System for Business Development — from idea to lasting business in Africa.',
  'mkt.footer.discover': 'Discover',
  'mkt.footer.services': 'Services',
  'mkt.footer.legal': 'Legal',
  'mkt.footer.presentation': 'Overview',
  'mkt.footer.parcours': 'Journey',
  'mkt.footer.offres': 'Offers',
  'mkt.footer.equipe': 'Team',
  'mkt.footer.marketplace': 'Marketplace',
  'mkt.footer.concours': 'Excellence Contest',
  'mkt.footer.contact': 'Contact',
  'mkt.footer.register': 'Sign up',
  'mkt.footer.privacy': 'Privacy policy',
  'mkt.footer.terms': 'Terms of use',
  'mkt.footer.writeUs': 'Write to us',
  'mkt.footer.login': 'Sign in',
  'mkt.footer.createAccount': 'Create an account',
  'mkt.footer.rights': '© {year} ISBD. All rights reserved.',
  'home.hero.kicker': 'Pan-African entrepreneurial development system',
  'home.hero.titleBefore': 'From idea to lasting business, ',
  'home.hero.titleEm': 'one integrated system',
  'home.hero.lead':
    'ISBD supports African entrepreneurs at every step: ideation, feasibility, business plan, rollout and operations — with the resources to succeed.',
  'home.hero.ctaStart': 'Start my project',
  'home.hero.ctaDiscover': 'Explore the journey',
  'home.stats.aria': 'Key figures',
  'home.stats.stepsLabel': 'steps',
  'home.stats.stepsText': 'from ideation to profitability',
  'home.stats.fundingLabel': 'funding',
  'home.stats.fundingText': 'available via the Excellence Contest',
  'home.stats.circlesLabel': 'circles',
  'home.stats.circlesText': 'of dedicated mentoring',
  'home.parcours.eyebrow': 'The ISBD journey',
  'home.parcours.title': 'An integrated system, from concept to lasting success',
  'home.parcours.lead':
    'Every step is digitally equipped and backed by strategic mentoring, grounded in the realities of the continent.',
  'home.parcours.alt': 'African entrepreneurs collaborating on their project',
  'home.step1.title': 'Ideation',
  'home.step1.text': 'Structure and qualify the business idea from the start.',
  'home.step2.title': 'Study & business plan',
  'home.step2.text': 'Feasibility, financial modeling and business plan.',
  'home.step3.title': 'Planning',
  'home.step3.text': 'Organize resources and prepare for rollout.',
  'home.step4.title': 'Rollout & operations',
  'home.step4.text': 'Launch the project and drive day-to-day execution.',
  'home.step5.title': 'Profitability & sustainability',
  'home.step5.text': 'Anchor performance and the longevity of the venture.',
  'home.offres.eyebrow': 'Our offers',
  'home.offres.title': 'Everything you need to build a lasting business',
  'home.offres.lead': 'Four complementary service families across the full entrepreneurial cycle.',
  'home.offer1.title': 'Project design',
  'home.offer1.text':
    'Guided ideation, feasibility studies and digitally assisted business plan modeling.',
  'home.offer1.alt': 'African entrepreneurs collaborating on a project',
  'home.offer2.title': 'Planning & rollout',
  'home.offer2.text': 'Concrete tools to organize and launch the project in the right conditions.',
  'home.offer2.alt': 'African entrepreneurs in a planning session',
  'home.offer3.title': 'Productivity management',
  'home.offer3.text':
    'Structured activity tracking to ensure execution and performance over time.',
  'home.offer3.alt': 'African professionals in an operations meeting',
  'home.offer4.title': 'Strategic mentoring',
  'home.offer4.text': 'Deep support to turn the venture into a profitable, lasting business.',
  'home.offer4.alt': 'Strategic mentoring between African entrepreneurs',
  'home.concours.eyebrow': 'Funding',
  'home.concours.title': 'Entrepreneurial Excellence Contest',
  'home.concours.lead':
    'Funding viable, high-impact projects. Free, reserved for ISBD subscribers — up to €15,000, interest-free repayment over three years.',
  'home.concours.point1': 'General contest — open to all subscribers',
  'home.concours.point2': 'Ambassadors contest — up to 250 projects / year',
  'home.concours.point3': 'Special contest — partner calls',
  'home.concours.cta': 'Become a subscriber',
  'home.marketplace.eyebrow': 'ISBD Marketplace',
  'home.marketplace.title': 'The subscribers’ shop, open to every visitor',
  'home.marketplace.lead':
    'Subscribers publish their products and services. Visitors browse listings and contact the seller — the subscriber receives the inquiry with the client’s details in their workspace.',
  'home.marketplace.aria': 'Marketplace atmospheres',
  'home.marketplace.cta': 'Explore the marketplace',
  'home.cat.mode': 'Fashion',
  'home.cat.agro': 'Agro-industry',
  'home.cat.commerce': 'Trade',
  'home.cat.services': 'Services',
  'home.cat.production': 'Production',
  'home.cat.logistics': 'Logistics',
  'home.ambition.title':
    'Raise a new generation of profitable, lasting African businesses',
  'home.ambition.lead':
    'ISBD aims to be the reference system for entrepreneurial development on the continent — digital, structured and designed for African entrepreneurs’ realities.',
  'home.team.eyebrow': 'Our team',
  'home.team.title': 'Three mentoring circles around you',
  'home.team.lead':
    'Every entrepreneur is surrounded by three complementary profiles, available as needed.',
  'home.circle1.title': 'Mentors',
  'home.circle1.text':
    'Experienced entrepreneurs who share their experience and help avoid destructive mistakes.',
  'home.circle1.alt': 'Entrepreneur mentor',
  'home.circle2.title': 'Expert trainers',
  'home.circle2.text':
    'Specialists who develop your know-how and entrepreneurial posture.',
  'home.circle2.alt': 'Business training expert',
  'home.circle3.title': 'Business advisors',
  'home.circle3.text':
    'Business development experts who guide you step by step toward growth.',
  'home.circle3.alt': 'Advisory team in a meeting',
  'home.final.title': 'Ready to structure your project with ISBD?',
  'home.final.lead': 'Join the integrated system — from idea to profitability.',
  'home.final.ctaRegister': 'Create an account',
  'home.final.ctaContact': 'Contact us',
  'pres.eyebrow': 'Overview',
  'pres.title': 'The ISBD journey',
  'pres.lead':
    'Structured mentoring from idea to operations, equipped and guided — designed for entrepreneurs across the African continent.',
  'pres.alt': 'Entrepreneur supported through their journey',
  'pres.cta': 'Join the platform',
  'sub.title': 'Subscription',
  'sub.subtitle': 'Choose the plan that fits your entrepreneurial journey and access all the system’s features.',
  'sub.current': 'Current plan',
  'sub.trial': 'Free trial',
  'sub.pay': 'Pay',
  'sub.payNext': 'Pay next installment',
  'sub.currentPlan': 'Current plan',
  'sub.history': 'History',
  'sub.trialBanner': 'Free trial: {days} day(s) left.',
  'sub.lockedBanner':
    'Your free trial has ended. Your account remains available; subscribe to unlock features.',
  'sub.none': 'None',
  'sub.pendingBanner':
    'Payment pending for the {plan} plan. The subscription will activate only after payment confirmation.',
  'sub.paymentSuccess': 'Payment confirmed. Your subscription is now active.',
  'sub.paymentPending': 'Your payment is not confirmed. The subscription is not active.',
  'sub.paymentError': 'Payment failed or was cancelled.',
  'sub.installments': '{paid}/{total} installment(s) paid',
  'sub.nextDue': 'Next installment: {date}',
  'sub.endsOn': 'Subscription ends: {date}',
  'sub.alertTrialExpiring':
    'Your free trial ends in {days} day(s). Subscribe to keep access.',
  'sub.alertSubscriptionExpiring':
    'Your {plan} subscription expires in {days} day(s). Renew to avoid interruption.',
  'sub.alertInstallmentDueSoon': 'A payment installment is due in {days} day(s).',
  'sub.alertInstallmentDueToday': 'A payment installment is due today.',
  'sub.alertInstallmentOverdue': 'A payment installment is overdue. Settle it to maintain access.',
  'sub.alertAction': 'Manage subscription',
  'sub.subscriptionEndedBanner':
    'Your subscription has expired. Renew to regain access to features.',
  'access.lockedTitle': 'Features locked',
  'access.lockedBody':
    'Your 14-day trial has ended. You can still view your profile and subscribe.',
  'access.goSubscribe': 'View plans',
  'profile.referralTitle': 'Referrals',
  'profile.referralShare': 'Share this link:',
  'profile.referralCount': '{count} referred person(s) in this cycle',
  'profile.referralResetHint': 'The counter resets on every resubscription.',
  'profile.konan': 'KONAN ID',
  'profile.vouchers': 'Vouchers',
  'premium.badge': 'Premium Shop',
  'premium.title': 'Products curated and verified by ISBD',
  'premium.empty': 'A selection of premium products and services, verified and recommended by ISBD.',
  'premium.cta': 'View featured product →',
};
